import { render } from "./BaseFeedbackScreen.vue?vue&type=template&id=360a5f58"
import script from "./BaseFeedbackScreen.vue?vue&type=script&lang=js"
export * from "./BaseFeedbackScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__